import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'create_invoice',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.retail_items[props.index] = next
    })
  }
}
